import { Component, Vue } from "vue-property-decorator";

import Panzoom, { PanzoomObject } from "@panzoom/panzoom";

@Component({
  components: {},
})
export default class PopupImageView extends Vue {
  panZoom: PanzoomObject | null = null;

  likedIcon = require("@/assets/icons/d-heart-fill-icon.svg");
  UnlikedIcon = require("@/assets/icons/d-like-empty-icon.svg");

  addVote = 0;
  votes = 0;

  get imageUrl() {
    return this.$store.state.popupImageDetails.imageUrl;
  }
  get imageName() {
    return this.$store.state.popupImageDetails.imageName;
  }
  get participantName() {
    return this.$store.state.popupImageDetails.participantName;
  }
  get description() {
    return this.$store.state.popupImageDetails.description;
  }
  get id() {
    return this.$store.state.popupImageDetails.id;
  }

  get windowWidth() {
    return window.innerWidth;
  }

  get reducewidthBy() {
    if (this.windowWidth < 500) return 0.8;
    return 0.5;
  }

  opened() {
    window.addEventListener("resize", this.changeWidth);

    const panElement = this.$refs.panElement as HTMLDivElement;
    if (panElement) {
      this.panZoom = Panzoom(panElement, {
        maxScale: 5,
        contain: "outside",
      });
      panElement!.parentElement!.addEventListener(
        "wheel",
        this.panZoom.zoomWithWheel
      );

      (this.$refs.zoomInEl as HTMLImageElement).onclick = this.panZoom.zoomIn;
      (this.$refs.zoomOutEl as HTMLImageElement).onclick = this.panZoom.zoomOut;
    }
  }

  beforeClosed() {
    window.removeEventListener("resize", this.changeWidth);
    if (this.panZoom) {
      const panElement = this.$refs.panElement as HTMLDivElement;
      panElement!.parentElement!.removeEventListener(
        "wheel",
        this.panZoom!.zoomWithWheel
      );
      this.panZoom.destroy();
      this.panZoom = null;
      (this.$refs.zoomInEl as HTMLImageElement).onclick = null;
      (this.$refs.zoomOutEl as HTMLImageElement).onclick = null;
    }
    this.$store.commit("clearPopupImageDetails");
    this.addVote = 0;
    this.votes = 0;
  }

  closeModal() {
    this.$modal.hide("pop-image-view");
  }

  changeWidth() {
    const windowWidth = window.innerWidth;
    let reducewidthBy = 0.8;
    if (windowWidth > 500 && windowWidth < 799) {
      reducewidthBy = 0.7;
    }
    if (windowWidth > 800) {
      reducewidthBy = 0.5;
    }

    if (this.$refs.modal) {
      (this.$refs.modal as any).modal.width = windowWidth * reducewidthBy;
    }
  }
}
